import React from "react";
import styles from "./MemberCard.module.css";
import { useNavigate } from "react-router-dom";
import { Phone, MessageCircle, Eye } from "lucide-react";

interface MemberCardProps {
  member: any;
  api: string;
}

export default function MemberCard({ member, api }: MemberCardProps) {
  const nav = useNavigate();

  const normalize = (r: string) => {
    if (!r) return r;
    const lower = r.toLowerCase();
    if (lower.includes("crore") || lower.includes("coro")) {
      return "Crorepati Giver";
    }
    return r;
  };

  const recognitionIcons: Record<string, string> = {
    "Crorepati Giver": "/images/crorepatiPin.webp",
    "Green Pin": "/images/greenPin.webp",
    "Gold Pin": "/images/goldPin.webp",
    "Leadership Pin": "/images/leadershipPin.webp",
  };

  const recognitions = Array.isArray(member.recognition)
    ? member.recognition.map(normalize)
    : [];

  return (
    <div
      className={styles.card}
      onClick={() => nav(`/member/${member._id}`)}
      role="button"
      tabIndex={0}
      onKeyDown={(e) => e.key === "Enter" && nav(`/member/${member._id}`)}
    >
      <div className={styles.cardTop}>
        <div className={styles.avatarWrap}>
          <div className={styles.avatarRing}>
            <img
              src={member.userImage || "/images/defaultAvatar.png"}
              alt={member.name}
              className={styles.avatar}
            />
          </div>
        </div>

        <div className={styles.meta}>
          <div className={styles.nameRow}>
            <h3 className={styles.name}>{member.name}</h3>
            <div className={styles.roleTag}>
              {member.memberType || "Member"}
            </div>
          </div>

          <p className={styles.company}>{member.orgName || "—"}</p>
          <p className={styles.businessCategory}>
            {member.businessCategory || "—"}
          </p>

          <div className={styles.badges}>
            {recognitions.length > 0 &&
              recognitions.map((rec: string) => {
                const iconSrc = recognitionIcons[rec];
                return (
                  iconSrc && (
                    <div className={styles.recPinWrap} key={rec}>
                      <img src={iconSrc} alt={rec} className={styles.recPin} />
                    </div>
                  )
                );
              })}
          </div>
        </div>
      </div>

      <div className={styles.cardBottom}>
        <div className={styles.contactRow}>
          {member.contactNo ? (
            <a
              href={`tel:${member.contactNo.replace(/[^\d]/g, "")}`}
              onClick={(e) => e.stopPropagation()}
              className={styles.iconButton}
              title="Call"
            >
              <Phone size={16} />
            </a>
          ) : (
            <div className={styles.iconButtonDisabled}>
              <Phone size={16} />
            </div>
          )}

          {member.whatsappNo ? (
            <a
              href={`https://wa.me/${member.whatsappNo.replace(/[^\d]/g, "")}`}
              onClick={(e) => e.stopPropagation()}
              target="_blank"
              rel="noreferrer"
              className={`${styles.iconButton} ${styles.wa}`}
              title="WhatsApp"
            >
              <MessageCircle size={16} />
            </a>
          ) : (
            <div className={styles.iconButtonDisabled}>
              <MessageCircle size={16} />
            </div>
          )}
        </div>

        <div className={styles.viewWrap}>
          <button
            onClick={(e) => {
              e.stopPropagation();
              nav(`/member/${member._id}`);
            }}
            className={styles.viewBtn}
            title="View Profile"
          >
            <Eye size={16} /> <span className={styles.viewText}>View</span>
          </button>
        </div>
      </div>
    </div>
  );
}
